import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAppointmentById } from "../../store/thunks/appointmentsThunk";
import {
  fetchInvoicePaymentsByAppointmentId,
  fetchPaymentsByInvoice,
} from "../../store/thunks/paymentsThunk";
import { setSelectedAppointment } from "../../store/slices/appointmentsSlice";
import InvoicePaymentModal from "../../modals/InvoicePaymentModal"; // Import the modal
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  Image,
  pdf,
} from "@react-pdf/renderer";
import logo from "../../assets/hearsay_logo.png";
import InvoiceModal from "./InvoiceModal";
import { saveAndEmailInvoice } from "../../store/thunks/invoiceThunk";
import { setCurrentInvoice } from "../../store/slices/invoiceSlice";

let totalPaid = 0;
let totalDepositUsed = 0;
let totalAmount = 0; // For the invoice total amount (e.g., $150 in your example)

const InvoiceGenerator = ({ initialViewMode = false, data = null }) => {
  const dispatch = useDispatch();

  const selectedAppointment = useSelector(
    (state) => state.appointments.selectedAppointment
  );
  const [viewMode, setViewMode] = useState(initialViewMode);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isSplitInvoiceModalOpen, setIsSplitInvoiceModalOpen] = useState(false);
  const [isEditInvoiceModalOpen, setIsEditInvoiceModalOpen] = useState(false);

  const invoiceData = useSelector((state) => state.invoices.currentInvoice);
  const paymentData = useSelector(
    (state) => state.payments.appointmentPayments
  );

  const onEditInvoice = () => {
    setIsEditInvoiceModalOpen(true);
  };

  const onSplitInvoice = () => {
    setIsSplitInvoiceModalOpen(true);
  };

  const saveAndEmailPDF = async () => {
    try {
      // Generate PDF blob
      const blob = await pdf(
        <MyDocument
          selectedAppointment={selectedAppointment}
          invoiceData={invoiceData}
          paymentData={paymentData}
        />
      ).toBlob();

      // Convert blob to base64
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = async () => {
        const base64data = reader.result.split(",")[1];

        const result = await dispatch(
          saveAndEmailInvoice({
            recipientEmail: selectedAppointment.client.email,
            invoicePdf: base64data,
            invoiceNumber: invoiceData.invoiceId,
            clientName:
              selectedAppointment.client.firstName +
              " " +
              selectedAppointment.client.lastName,
            amount: invoiceData.amount,
          })
        ).unwrap();

        alert("Invoice has been emailed to client");
      };
    } catch (error) {
      console.error("Error sending invoice:", error);
      alert("Failed to send invoice. Please try again.");
    }
  };

  useEffect(() => {
    dispatch(setCurrentInvoice(invoiceData));
  }, [invoiceData]);

  useEffect(() => {
    if (invoiceData?.appointmentId) {
      // Dispatch fetchAppointmentById and set selected appointment
      dispatch(fetchAppointmentById(invoiceData.appointmentId))
        .unwrap()
        .then((appointment) => {
          dispatch(setSelectedAppointment(appointment));
        })
        .catch((error) => {
          console.error(
            `Failed to fetch appointment with ID ${invoiceData.appointmentId}:`,
            error
          );
        });

      // Dispatch fetchPaymentsByInvoice with invoiceData._id
      dispatch(fetchInvoicePaymentsByAppointmentId(invoiceData.appointmentId))
        .unwrap()
        .then((payments) => {
          console.log(
            "hELLO FETCHING PAYMENT BY INBVOICE Fetched payments for invoice:",
            payments
          );
        })
        .catch((error) => {
          console.error(
            `Failed to fetch payments for invoice with ID ${invoiceData._id}:`,
            error
          );
        });
    }
  }, [dispatch, invoiceData]);

  console.log("invoice generator opened");
  console.log("Invoice data", invoiceData);
  console.log("Payment data", paymentData);
  console.log("Selected appointment (fetched)", selectedAppointment);

  return (
    <div className="bg-white rounded-sm shadow-sm border border-gray-200 p-6 space-y-6">
      {/* Status Information */}
      <div className="bg-gray-50 rounded-sm border border-gray-200 p-4">
        <div className="flex items-center space-x-3">
          <div className="h-10 w-10 rounded-full bg-blue-600 flex items-center justify-center">
            <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              Current Status
            </h3>
            <p className="text-sm text-gray-600 mt-0.5">
              {invoiceData
                ? invoiceData.status === "created"
                  ? "Invoiced"
                  : `${invoiceData.status} - ${invoiceData.invoiceId}`
                : "No Invoice Data"}
            </p>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3">
        <button
          onClick={() => setIsPaymentModalOpen(true)}
          className="inline-flex items-center justify-center px-4 py-2.5 bg-green-600 text-white text-sm font-semibold rounded-sm shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600 transition-colors">
          <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
          </svg>
          Collect Payment
        </button>
        
        <button
          onClick={saveAndEmailPDF}
          className="inline-flex items-center justify-center px-4 py-2.5 bg-blue-600 text-white text-sm font-semibold rounded-sm shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 transition-colors">
          <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 7.89a2 2 0 002.83 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          Email to Client
        </button>
        
        <button
          onClick={() => {
            window.location.href = `/payment/checkout/${invoiceData._id}`;
          }}
          className="inline-flex items-center justify-center px-4 py-2.5 bg-indigo-600 text-white text-sm font-semibold rounded-sm shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 transition-colors">
          <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
          </svg>
          Email Payment Link
        </button>
        
        <button
          onClick={() => onEditInvoice(invoiceData)}
          className="inline-flex items-center justify-center px-4 py-2.5 bg-gray-600 text-white text-sm font-semibold rounded-sm shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-600 transition-colors">
          <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          Edit Invoice
        </button>
        
        <button
          onClick={() => onSplitInvoice(invoiceData)}
          className="inline-flex items-center justify-center px-4 py-2.5 bg-orange-600 text-white text-sm font-semibold rounded-sm shadow-sm hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-600 transition-colors">
          <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
          </svg>
          Convert to Split
        </button>
      </div>

      {/* PDF Viewer */}
      <div className="border border-gray-200 rounded-sm overflow-hidden">
        <div className="bg-gray-50 px-4 py-3 border-b border-gray-200">
          <h4 className="text-sm font-medium text-gray-900">Invoice Preview</h4>
        </div>
        <div className="p-4 bg-white">
          <PDFViewer
            style={{
              width: "100%",
              height: "600px",
              border: "none",
            }}>
            <MyDocument
              selectedAppointment={selectedAppointment}
              invoiceData={invoiceData}
              paymentData={paymentData}
            />
          </PDFViewer>
        </div>
      </div>

      {/* Invoice Payment Modal */}
      {isPaymentModalOpen && (
        <InvoicePaymentModal
          // invoice={invoiceData}
          onClose={async () => {
            setIsPaymentModalOpen(false); // Close the modal
          }}
        />
      )}

      {isSplitInvoiceModalOpen && (
        <InvoiceModal
          appointment={selectedAppointment}
          convertInvoice={invoiceData} // Pass convertInvoice to modal
          onClose={() => setIsSplitInvoiceModalOpen(false)}
        />
      )}

      {isEditInvoiceModalOpen && (
        <InvoiceModal
          appointment={selectedAppointment}
          editInvoice={invoiceData}
          onClose={() => setIsEditInvoiceModalOpen(false)}
        />
      )}
    </div>
  );
};

export default InvoiceGenerator;

const MyDocument = ({ selectedAppointment, invoiceData, paymentData }) => {
  console.log("My document selectedAppointment", selectedAppointment);
  console.log("My document invoiceData", invoiceData);
  console.log("My document paymentData", paymentData);
  // const clinic = selectedAppointment?.clinic || {};
  // const clinician = selectedAppointment?.clinician || {};
  // const client = selectedAppointment?.client || {};
  // const address = selectedAppointment?.client?.address || {};
  const clinic = invoiceData?.clinic || {};
  const clinician = invoiceData?.clinician || {};
  const client = invoiceData?.client || {};
  const insurer = invoiceData?.billTo || {};
  const billToType = invoiceData?.billToType || "client";
  const address = invoiceData?.client?.address || {};
  const services = invoiceData?.services || [];
  const parentInfo = selectedAppointment?.splitBilling?.parentInfo || {};
  const paymentInfo = Array.isArray(paymentData) ? paymentData : [];

  console.log("Payment Info", paymentInfo);

  const calculateSubtotal = (services) => {
    return services.reduce(
      (acc, service) => acc + service.cost * service.quantity,
      0
    );
  };

  const calculateTax = (services) => {
    return services.reduce((acc, service) => {
      if (service.isTaxable && service.taxRate && service.taxRate > 0) {
        return acc + service.cost * service.quantity * service.taxRate;
      }
      return acc;
    }, 0);
  };

  const subtotal = calculateSubtotal(services);
  const tax = calculateTax(services);
  const total = subtotal + tax;

  const totalPayments = paymentInfo.reduce((sum, paymentItem) => {
    const payment = paymentItem.payment || paymentItem;
    if (!payment) return sum;

    // Check if this payment belongs to this invoice
    const isForThisInvoice =
      payment.invoiceId?.invoiceId === invoiceData.invoiceId ||
      (Array.isArray(payment.invoiceId) &&
        payment.invoiceId.some(inv => inv.invoiceId === invoiceData.invoiceId));

    if (!isForThisInvoice) return sum;

    let paymentSum = sum;
    // Only count direct payment if not a deposit
    if (!payment.deposit) {
      paymentSum += payment.amount || 0;
    }
    // Only count deposit usage for this invoice
    if (payment.deposit && Array.isArray(payment.depositUsage)) {
      paymentSum += payment.depositUsage
        .filter(dep => dep.invoiceId === invoiceData._id || dep.invoiceNumber === invoiceData.invoiceId)
        .reduce((depSum, dep) => depSum + (dep.amountUsed || 0), 0);
    }
    return paymentSum;
  }, 0);

  const balanceDue = (total || 0) - totalPayments;

  console.log("Total Payments", totalPayments);
  console.log("Balance Due", balanceDue);

  let formattedDate = "";
  let formattedTime = "";

  if (invoiceData.updatedAt) {
    formattedDate = new Date(invoiceData.updatedAt).toLocaleDateString(
      "en-US",
      {
        month: "long",
        day: "numeric",
        year: "numeric",
      }
    );

    formattedTime = new Date(invoiceData.updatedAt).toLocaleTimeString(
      "en-US",
      {
        timeStyle: "long",
      }
    );
  }

  console.log("Payment Info", paymentInfo);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header with logo */}
        <View style={styles.header}>
          <Image style={styles.logo} src={logo} />
          <View style={{ alignItems: "flex-end" }}>
            <Text style={{ fontSize: 12, fontWeight: "bold" }}>
              {clinic.name}
            </Text>
            <Text style={styles.text}>{clinic.address?.street || ""}</Text>
            <Text style={styles.text}>
              {`${clinic.address?.city || ""}, ${
                clinic.address?.province || ""
              }, ${clinic.address?.postalCode || ""}`}
            </Text>
          </View>
        </View>

        {/* Clinician and Invoice info */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-evenly",
            width: "100%",
            marginVertical: 10,
            paddingBottom: 20,
          }}>
          <View style={{ flexBasis: "70%" }}>
            <Text style={styles.text}>
              {clinician.firstName} {clinician.lastName}
            </Text>
            <Text style={styles.text}>{clinician.invoiceDescriptor}</Text>
          </View>

          <View style={{ flexBasis: "30%", alignItems: "flex-end" }}>
            <Text style={styles.text}>Invoice: {invoiceData.invoiceId}</Text>
            <Text style={styles.text}>
              Service Date:{" "}
              {new Date(invoiceData.serviceDate).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              })}
            </Text>
          </View>
        </View>

        {/* Client and Bill To */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-evenly",
            width: "100%",
          }}>
          {/* Client */}
          <View
            style={{
              marginBottom: 20,
              borderWidth: 1,
              flex: 1,
              marginRight: 10,
            }}>
            <View
              style={{
                borderBottom: 1,
                paddingHorizontal: 10,
                paddingVertical: 6,
              }}>
              <Text style={styles.text}>Client</Text>
            </View>
            <View
              style={{
                paddingVertical: 8,
                paddingHorizontal: 10,
              }}>
              <Text style={styles.text}>{`${(client.firstName || "").trim()} ${(
                client.lastName || ""
              ).trim()}`}</Text>
              <Text style={styles.text}>
                {address.aptUnit ? `${address.aptUnit} - ` : ""}
                {`${address.streetNumber || ""} ${address.streetName || ""}`}
              </Text>

              <Text style={styles.text}>{`${address.city || ""}, ${
                address.province || ""
              }, ${address.postalCode || ""}`}</Text>
            </View>
          </View>

          {/* Bill To */}
          <View
            style={{
              marginBottom: 20,
              borderWidth: 1,
              flex: 1,
              marginLeft: 10,
            }}>
            <View
              style={{
                borderBottom: 1,
                paddingHorizontal: 10,
                paddingVertical: 6,
              }}>
              <Text style={styles.text}>Bill To</Text>
            </View>
            <View
              style={{
                paddingVertical: 8,
                paddingHorizontal: 10,
              }}>
              {billToType === "insurer" ? (
                <>
                  <Text style={styles.text}>{insurer.name || ""}</Text>
                  <Text style={styles.text}>
                    {`${
                      insurer.address?.aptNumber
                        ? insurer.address.aptNumber + " - "
                        : ""
                    }${insurer.address?.street || ""}`}
                  </Text>
                  <Text style={styles.text}>{`${insurer.address?.city || ""}, ${
                    insurer.address?.province || ""
                  }, ${insurer.address?.postalCode || ""}`}</Text>
                </>
              ) : (
                <>
                  <Text style={styles.text}>{`${(parentInfo._id
                    ? parentInfo.firstName
                    : client.firstName || ""
                  ).trim()} ${(parentInfo._id
                    ? parentInfo.lastName
                    : client.lastName || ""
                  ).trim()}`}</Text>
                  <Text style={styles.text}>
                    {`${
                      parentInfo._id
                        ? parentInfo.address?.aptUnit
                          ? `${parentInfo.address.aptUnit} - `
                          : ""
                        : client.address?.aptUnit
                        ? `${client.address.aptUnit} - `
                        : ""
                    }${
                      parentInfo._id
                        ? parentInfo.address?.streetNumber || ""
                        : client.address?.streetNumber || ""
                    } ${
                      parentInfo._id
                        ? parentInfo.address?.streetName || ""
                        : client.address?.streetName || ""
                    }`}
                  </Text>

                  <Text style={styles.text}>{`${
                    parentInfo._id
                      ? parentInfo.address?.city || ""
                      : client.address?.city || ""
                  }, ${
                    parentInfo._id
                      ? parentInfo.address?.province || ""
                      : client.address?.province || ""
                  }, ${
                    parentInfo._id
                      ? parentInfo.address?.postalCode || ""
                      : client.address?.postalCode || ""
                  }`}</Text>
                </>
              )}
            </View>
          </View>
        </View>

        {/* Charges Table */}
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={{ ...styles.tableColHeader, width: "50%" }}>
              <Text style={styles.tableCell}>Description</Text>
            </View>
            <View style={{ ...styles.tableColHeader, width: "5%" }}>
              <Text style={styles.tableCell}>Qty</Text>
            </View>
            <View style={{ ...styles.tableColHeader, width: "30%" }}>
              <Text style={styles.tableCell}>Notes</Text>
            </View>
            <View style={{ ...styles.tableColHeader, width: "15%" }}>
              <Text style={styles.tableCell}>Amount</Text>
            </View>
          </View>

          {/* Services Rows */}
          {services.map((service, index) => (
            <View key={index} style={styles.tableRow}>
              <View style={{ ...styles.tableCol, width: "50%" }}>
                <Text style={styles.tableCell}>{service.description}</Text>
              </View>
              <View
                style={{
                  ...styles.tableCol,
                  width: "5%",
                  alignItems: "flex-end",
                }}>
                <Text style={styles.tableCell}>{service.quantity}</Text>
              </View>
              <View style={{ ...styles.tableCol, width: "30%" }}>
                <Text style={styles.tableCell}>{service.notes}</Text>
              </View>
              <View
                style={{
                  ...styles.tableCol,
                  width: "15%",
                  alignItems: "flex-end",
                }}>
                <Text style={styles.tableCell}>
                  ${(service.cost * service.quantity)?.toFixed(2)}
                </Text>
              </View>
            </View>
          ))}

          {/* Subtotal Row */}
          <View style={styles.tableRow}>
            <View
              style={{
                ...styles.tableCol,
                width: "85%",
                borderRightWidth: 1,
                alignItems: "flex-end",
              }}>
              <Text style={styles.tableCell}>Subtotal</Text>
            </View>
            <View
              style={{
                ...styles.tableCol,
                width: "15%",
                alignItems: "flex-end",
              }}>
              <Text style={styles.tableCell}>${subtotal?.toFixed(2)}</Text>
            </View>
          </View>

          {/* Taxes Row */}
          <View style={styles.tableRow}>
            <View
              style={{
                ...styles.tableCol,
                width: "85%",
                borderRightWidth: 1,
                alignItems: "flex-end",
              }}>
              <Text style={styles.tableCell}>Tax</Text>
            </View>
            <View
              style={{
                ...styles.tableCol,
                width: "15%",
                alignItems: "flex-end",
              }}>
              <Text style={styles.tableCell}>${tax?.toFixed(2)}</Text>
            </View>
          </View>

          {/* Total Row */}
          <View style={styles.tableRow}>
            <View
              style={{
                ...styles.tableCol,
                width: "85%",
                borderRightWidth: 1,
                alignItems: "flex-end",
              }}>
              <Text style={styles.tableCell}>Total</Text>
            </View>
            <View
              style={{
                ...styles.tableCol,
                width: "15%",
                alignItems: "flex-end",
              }}>
              <Text style={styles.tableCell}>${total?.toFixed(2)}</Text>
            </View>
          </View>

          {/* Payments Section */}
          {Array.isArray(paymentInfo) && paymentInfo.length > 0 && (
            <>
              {paymentInfo.map((paymentItem, index) => {
                const payment = paymentItem.payment || paymentItem;
                if (!payment) return null;

                // Check if this payment belongs to this invoice
                const isForThisInvoice =
                  payment.invoiceId?.invoiceId === invoiceData.invoiceId ||
                  (Array.isArray(payment.invoiceId) &&
                    payment.invoiceId.some(inv => inv.invoiceId === invoiceData.invoiceId));

                if (!isForThisInvoice) return null;

                return (
                  <React.Fragment key={index}>
                    {/* Only show as payment if not a deposit */}
                    {!payment.deposit && payment.amount > 0 && (
                      <View style={styles.tableRow}>
                        <View
                          style={{
                            ...styles.tableCol,
                            width: "85%",
                            borderRightWidth: 1,
                            alignItems: "flex-end",
                          }}>
                          <Text style={styles.tableCell}>
                            {`Payment $${(payment.amount || 0).toFixed(2)} (${
                              payment.paymentMethod
                                ? (clinic.paymentMethods || []).find(
                                    (method) => method.value === payment.paymentMethod
                                  )?.englishDescription ||
                                  payment.paymentMethod
                                : "Unknown Method"
                            }) - ${new Date(
                              payment.paymentDate
                            ).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                              timeZone: "UTC",
                            })}`}
                          </Text>
                        </View>
                        <View
                          style={{
                            ...styles.tableCol,
                            width: "15%",
                            alignItems: "flex-end",
                          }}>
                          <Text style={styles.tableCell}>
                            -${(payment.amount || 0).toFixed(2)}
                          </Text>
                        </View>
                      </View>
                    )}
                    {/* Only show deposit usage lines for this invoice */}
                    {payment.deposit && Array.isArray(payment.depositUsage) &&
                      payment.depositUsage
                        .filter(dep => dep.invoiceId === invoiceData._id || dep.invoiceNumber === invoiceData.invoiceId)
                        .map((deposit, dIndex) => (
                          <View
                            style={styles.tableRow}
                            key={`${index}-${dIndex}`}>
                            <View
                              style={{
                                ...styles.tableCol,
                                width: "85%",
                                borderRightWidth: 1,
                                alignItems: "flex-end",
                              }}>
                              <Text style={styles.tableCell}>
                                {`Deposit Applied $${(deposit.amountUsed || 0).toFixed(2)} (${
                                  payment.paymentMethod
                                    ? (clinic.paymentMethods || []).find(
                                        (method) => method.value === payment.paymentMethod
                                      )?.englishDescription ||
                                      payment.paymentMethod
                                    : "Unknown Method"
                                }) - ${new Date(
                                  deposit.dateUsed
                                ).toLocaleDateString("en-US", {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                                  timeZone: "UTC",
                                })}`}
                              </Text>
                            </View>
                            <View
                              style={{
                                ...styles.tableCol,
                                width: "15%",
                                alignItems: "flex-end",
                              }}>
                              <Text style={styles.tableCell}>
                                -${(deposit.amountUsed || 0).toFixed(2)}
                              </Text>
                            </View>
                          </View>
                        ))}
                  </React.Fragment>
                );
              })}
            </>
          )}

          {/* Balance Due Row */}
          <View style={styles.tableRow}>
            <View
              style={{
                ...styles.tableCol,
                width: "85%",
                borderRightWidth: 1,
                alignItems: "flex-end",
              }}>
              <Text style={styles.tableCell}>Balance Due</Text>
            </View>
            <View
              style={{
                ...styles.tableCol,
                width: "15%",
                alignItems: "flex-end",
              }}>
              <Text style={styles.tableCell}>${balanceDue?.toFixed(2)}</Text>
            </View>
          </View>
        </View>
        {/* Notes Section */}
        <View
          style={{
            marginTop: 20,
          }}>
          <Text style={styles.text}>Notes</Text>
          <View
            style={{
              marginTop: 5,
              padding: 5,
              borderWidth: 1,
              width: "100%",
              minHeight: 60,
            }}>
            <Text style={styles.text}>{invoiceData.notes}</Text>
          </View>
        </View>

        {/* Signature */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            marginTop: 50,
          }}>
          {" "}
          <Text style={styles.text}>
            Signature: ________________________________
          </Text>
          <Text style={styles.text}>
            Date: ________________________________
          </Text>
        </View>

        <View
          style={{
            flex: 1,
            justifyContent: "flex-end",
            alignItems: "center",
          }}>
          <Text style={{ fontSize: 8 }}>
            [Version {invoiceData.__v + 1}. Last updated on {formattedDate}{" "}
            {formattedTime}]
          </Text>
        </View>
      </Page>
    </Document>
  );
};

// Styles for the PDF document
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 30,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  logo: {
    maxWidth: 180,
    maxHeight: 100,
    width: "auto",
    height: "auto",
  },

  borderSection: {
    marginBottom: 20,
    borderWidth: 1,
  },
  title: {
    fontSize: 18,
    marginBottom: 10,
  },
  text: {
    fontSize: 12,
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#D3D3D3",
  },
  tableCol: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    margin: 5,
    fontSize: 10,
  },
});
